import type { Item } from '@aha-app/selectro-v2';

export const resolveAttribute = (item: Item, attribute: string) => {
  // Try all the possible places the attribute could be.
  return item[attribute] || item.data?.[attribute] || item.meta?.[attribute];
};
